const API_URL = import.meta.env.VITE_API_URL;

export const ORG_TYPES = {
    // 個人
    KOJIN: 'kojin',                      // 個人事業主（青色申告）
    // 営利法人
    KABUSHIKI: 'kabushiki',              // 株式会社
    GODO: 'godo',                        // 合同会社
    // 非営利法人（一般）
    IPPAN_SHADAN: 'ippan-shadan',        // 一般社団法人
    IPPAN_ZAIDAN: 'ippan-zaidan',        // 一般財団法人
    NPO: 'npo',                          // NPO法人
};

export const ORG_TYPE_LABELS = {
    [ORG_TYPES.KOJIN]: '個人事業主',
    [ORG_TYPES.KABUSHIKI]: '株式会社',
    [ORG_TYPES.GODO]: '合同会社',
    [ORG_TYPES.IPPAN_SHADAN]: '一般社団法人',
    [ORG_TYPES.IPPAN_ZAIDAN]: '一般財団法人',
    [ORG_TYPES.NPO]: 'NPO法人',
};

// 法人種別の判定ヘルパー
export const isIndividual = (orgType) => orgType === ORG_TYPES.KOJIN;
export const isForProfit = (orgType) => [ORG_TYPES.KABUSHIKI, ORG_TYPES.GODO].includes(orgType);
export const isNonProfit = (orgType) => [
    ORG_TYPES.IPPAN_SHADAN, ORG_TYPES.IPPAN_ZAIDAN, ORG_TYPES.NPO
].includes(orgType);
export const isNPO = (orgType) => orgType === ORG_TYPES.NPO;
// 一般社団/財団法人（NPO以外の非営利法人）
export const isGeneralNonProfit = (orgType) => [
    ORG_TYPES.IPPAN_SHADAN, ORG_TYPES.IPPAN_ZAIDAN
].includes(orgType);
export const isCorporation = (orgType) => !isIndividual(orgType);
// 一般社団法人の普通型（営利型）は税務上営利法人と同等扱い
export const isEffectivelyForProfit = (orgType, subType) => {
    if (isForProfit(orgType)) return true;
    if (orgType === ORG_TYPES.IPPAN_SHADAN && subType === 'forprofit') return true;
    return false;
};

// 組織情報の取得（同期的、localStorageから）
export const getOrgInfo = () => {
    const saved = localStorage.getItem('toiro_org_info');
    if (saved) {
        try {
            return JSON.parse(saved);
        } catch (e) {
            console.error('Failed to parse org info:', e);
            return null;
        }
    }
    return null;
};

// 組織情報をAPIから読み込み
export const loadOrgFromApi = async (userEmail) => {
    if (!userEmail) {
        throw new Error('ユーザーメールが必要です');
    }
    try {
        const response = await fetch(`${API_URL}?action=getOrg&user=${encodeURIComponent(userEmail)}`);
        if (response.ok) {
            const data = await response.json();
            if (data.org) {
                return data.org;
            }
        }
        throw new Error('組織情報の読み込みに失敗しました');
    } catch (e) {
        console.error('Failed to load org from API:', e);
        throw e;
    }
};

// 組織情報をAPIに保存
export const saveOrgInfo = async (orgInfo, userEmail) => {
    if (!userEmail) {
        throw new Error('ユーザーメールが必要です');
    }
    try {
        const response = await fetch(`${API_URL}?action=saveOrg&user=${encodeURIComponent(userEmail)}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ org: orgInfo })
        });
        if (!response.ok) {
            throw new Error('組織情報の保存に失敗しました');
        }
        return true;
    } catch (e) {
        console.error('Failed to save org to API:', e);
        throw e;
    }
};
